import OrderAdminAPICall from "../../service/AdminAPICalls/OrderAdminAPICall";

class OrderAdminRepository{

  getAdminOrderList = async (params) => {
    return new OrderAdminAPICall().getAdminOrderList(params);
  }

  getAdminOrderInsightInfo = async (params) => {
    return await new OrderAdminAPICall().getAdminOrderInsightInfo(params);
  }

  getAdminOrderInsightList = async (params) => {
    return await new OrderAdminAPICall().getAdminOrderInsightList(params);
  }

  adminOrderReprocess = async (params) => {
    return await new OrderAdminAPICall().adminOrderReprocess(params);
  }

  getOrderInsightExportAll = async (params) => {
    return await new OrderAdminAPICall().getOrderInsightExportAll(params);
  }
  getOrderAuditLog = async (params) => {
    return await new OrderAdminAPICall().getOrderAuditLog(params);
  }
  updateAdminOrderDetails = async (params) => {
    return await new OrderAdminAPICall().updateAdminOrderDetails(params);
  }
}

export default OrderAdminRepository;